export default __webpack_public_path__ + "static/media/marginalia-girl-computer.1d85c55d.svg";